import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ContractSettlementsPage } from "@/features/contracts/contract-settlements-page";
import { ensureElementVisible } from "@/lib/route-guards";

// Filtry w URL, nie w useState: bez tego powrot ze szczegolow kontraktu
// (strzalka wstecz) montowal liste od zera i kasowal wybor uzytkownika.
// Przy okazji widok jest linkowalny i przezywa odswiezenie strony.
//
// Kazde pole ma `.catch(undefined)` — zly parametr ze starej zakladki nie
// moze wywalic trasy ZodErrorem (incydenty FARMASTER-FRONTEND-31/33/34).
// `rok` i `opiekun` przez union+transform: parser TanStacka konwertuje
// wartosci numeryczne na `number`, a komponent trzyma je jako stringi.
const searchSchema = z.object({
	szukaj: z.string().optional().catch(undefined),
	producent: z.string().optional().catch(undefined),
	opiekun: z.union([z.string(), z.number()]).transform(String).optional().catch(undefined),
	rok: z.union([z.string(), z.number()]).transform(String).optional().catch(undefined),
	okres: z.string().optional().catch(undefined),
	/** Klucz kolumny sortowania; `brak` = uzytkownik wyczyscil sortowanie. */
	sort: z.string().optional().catch(undefined),
	kierunek: z.enum(["asc", "desc"]).optional().catch(undefined),
	estymacja: z.boolean().optional().catch(undefined),
});

export type ContractSettlementsSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/kontrakty/rozliczenia/")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.szablony",
			location.pathname,
		);
	},
	component: ContractSettlementsPage,
	validateSearch: (search: Record<string, unknown>): ContractSettlementsSearch =>
		searchSchema.parse(search),
});
